import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const VirtualAuthorEvents = () => <EventCategoryPage config={EVENT_CATEGORIES['virtual-author-events']} data-id="element-9190" data-mp="1oad5bt233oc8" />;
export default VirtualAuthorEvents;